export const generateClassPropertyValue = (className: string, property: string, value: number, unit = 'px'): string => {
  return `.${className}-${value} { ${property}: ${value}${unit}; }`;
};
